export default __webpack_public_path__ + "static/media/shopping-cart.37ee1b3c.png";